import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export default function UpgradeComplete() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (!searchParams.get("session_id")) {
      const timer = window.setTimeout(() => {
        window.location.assign("/app/settings/billing?setup=1");
      }, 4000);
      return () => window.clearTimeout(timer);
    }
  }, [searchParams]);

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-4">
      <div className="h-10 w-10 animate-spin rounded-full border-4 border-indigo-600 border-t-transparent" />
      <h1 className="mt-4 text-lg font-semibold text-gray-900 dark:text-white">
        Activating your paid plan…
      </h1>
      <p className="mt-2 max-w-md text-center text-sm text-gray-600 dark:text-gray-400">
        We&apos;re linking your Stripe subscription and opening the billing setup
        wizard so you can connect Stripe and migrate your students.
      </p>
    </div>
  );
}
